import React from 'react';
import Page from "components/Page";
import {ActionCard} from "../../../components/ActionCard";
import {useNavigate} from "react-router-dom";
import visitorDensityIcon from "assets/visitor-density.svg";
import visitorMovementIcon from "assets/visitor-movement.svg";

// Helpers ----

const breadcrumbs = {"Performance": "/", "User Behaviour": "/insights/visitors"}

// Component ----

function VisitorInsights() {
  const navigate = useNavigate();

  return (
    <Page title="User Behaviour" subTitle='Understand more about the dwell time and movement of app users' breadcrumbs={breadcrumbs}>
      <div className='grid grid-cols-[repeat(auto-fill,_minmax(300px,_1fr))] gap-6'>
        <ActionCard
          imageSrc={visitorDensityIcon}
          heading='Density'
          description='Visualise where visitors spend the most time across your site. Heatmaps combine location signals and beacon triggers to reveal high-traffic areas.'
          buttonText='View Density Map'
          onClick={() => navigate('/insights/visitors/density')}
        />

        {/*<ActionCard*/}
        {/*  imageSrc={visitorLocationIcon}*/}
        {/*  heading='Location'*/}
        {/*  description='See where visitors using the mobile app are located across your site in real time, helping you understand current distribution and activity.'*/}
        {/*  buttonText='View Visitor Locations'*/}
        {/*  onClick={() => navigate('/insights/visitors/location')}*/}
        {/*/>*/}

        <ActionCard
          imageSrc={visitorMovementIcon}
          heading='Movement'
          description='Explore the paths visitors take around your attraction. Select an individual visitor to see their journey mapped step-by-step across the site.'
          buttonText='View Visitor Movement'
          onClick={() => navigate('/insights/visitors/movement')}
        />
      </div>

    </Page>
  );
}

export default VisitorInsights;